import i18n from "i18n";

class Account {
  id = null;
  first_name = null;
  last_name = null;
  phone = null;
  email = null;
  country = null;
  language = null;
  nodes = null;

  constructor(obj) {
    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
    for (var prop in obj) this[prop] = obj[prop];
  }

  getEditPanelView() {
    return [
      {
        title: i18n.t("name"),
        value: this.first_name,
      },
      {
        title: i18n.t("surname"),
        value: this.last_name,
      },
      {
        title: i18n.t("phone"),
        value: this.phone,
      },
      {
        title: i18n.t("email"),
        value: this.email,
      },
      {
        title: i18n.t("language"),
        value: this.language,
      },
      {
        title: i18n.t("branch.offices"),
        value: this.nodes.map((n) => n.name).join(", "),
      },
    ];
  }
}

export { Account };
